import jQuery from 'jquery/dist/jquery'
window.jQuery = jQuery

import '../scss/theme.scss';

import 'slick-carousel/slick/slick'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'

const watchScroll = () => {
    if (document.body.classList.contains('top') && window.scrollY > 300) {
        document.body.classList.remove('top')
    }
    else if (!document.body.classList.contains('top') && window.scrollY <= 300) {
        document.body.classList.add('top')
    }
}

window.addEventListener('load', () => {
    document.querySelector('#toggle-searchbar')
        .addEventListener('click', () => {
            if ('#search' === location.hash) {
                location.hash = ''
            } else {
                location.hash = 'search'
            }
        })

    jQuery('.slider').slick({
        arrows: false,
        autoplay: true,
        dots: true
    });

    watchScroll()
    window.addEventListener('scroll', watchScroll)

    document.getElementById('arrow-up').addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()
        window.scrollTo({top: 0, behavior: 'smooth'});
    })
})
